enum FontOptions {
  default = 'true',
  custom = 'false',
}

export default FontOptions;
